import { Link } from '@com-delta-idp/mnx-ui-kit';
import { DisplayProperties } from '../../../models';

export interface Summary extends DisplayProperties {
  level?: string;
  title: string;
  description?: string;
  value: string;
  action: Link;
  ariaLabels: SummaryAriaLabels;
}

export interface SummaryAriaLabels {
  level?: string;
  title: string;
}

export interface SummaryAnalyticsEvent {
  action: Link;
  eventType: string;
  event?: string;
  type?: string;
  id?: string;
}
